<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-8 align-self-center">
      <h2>{{ $t("navigations.manage program") }}</h2>
    </div>
    <div class="col-lg-4 text-right align-self-center">
      <span class="tooltip-wrapper pointer">
        <i class="fa fa-times close text-black" @click="closeScreen()"></i>
        <span class="custom-tooltip">Close</span>
      </span>
    </div>
  </div>
  <div class="wrapper wrapper-content px-0">
    <div class="ibox-content mb-1 px-3 py-2">
      <div class="row mx-0">
        <div class="col-12 col-md-3 my-1 pl-lg-1 pr-lg-0">
          <div class="form-group mb-md-0">
            <label for="programName"
              >{{ $t("navigations.program title")
              }}<sup><i class="fa fa-asterisk important-block px-1"></i></sup
            ></label>
            <input
              id="programName"
              type="text"
              class="form-control my-md-2 my-lg-0"
              v-model="programName"
            />
            <span class="errormsg ml-0" v-if="validations[0] == true">
              {{ $t("navigations.please enter a value") }}
            </span>
          </div>
        </div>
        <div class="col-12 col-md-3 my-1 pl-lg-1 pr-lg-0">
          <div class="form-group mb-md-0">
            <label for="fileName">{{ $t("navigations.location type")
              }}<sup><i class="fa fa-asterisk important-block px-1"></i></sup></label>
            <select 
              name="location" placeholder="Search"
              class="form-select my-md-2 my-lg-0"  
              @change="locationChanged()"
              v-model="LocationType" id="fileName" disabled>
                <option value=""  > None</option>
                <option value="database"> Database</option>
                <option value="datalake"> Data Lake </option>
            </select>
            <span class="errormsg ml-0" v-if="validations[1] == true">
              {{ $t("navigations.please choose a value") }}
            </span>
          </div>
        </div>
        
        <div class="col-12 col-md-2 my-1 pl-lg-1 pr-lg-0">
          <div class="form-group mb-md-0">
            <label for="fileName">{{ $t("navigations.interim version")}}</label>
            <select 
              name="interim version" placeholder="Search"
              class="form-select my-md-2 my-lg-0"  
              @change="changeInterimVersion()"
              v-model="selectedIntVersion" id="interimVersion" disabled>
              <option :value="selectedIntVersion">{{ selectedIntVersion || 'None' }}
                <!-- <option value="" slected > None</option>
                <option v-for="version in interimVersions" :key="version" :value="version">
                {{ version }} -->
              </option>
            </select>
            <!-- <span class="errormsg ml-0" v-if="validations[3] == true">
              {{ $t("navigations.please choose a value") }}
            </span> -->
          </div>
        </div>

        <div class="col-12 col-md-4 my-1 pl-lg-1 pr-lg-1" v-if="LocationType == 'database'">
          <div class="form-group mb-md-0">
            <label for="fileName">{{ $t("navigations.dataset location")
              }}<sup><i class="fa fa-asterisk important-block px-1"></i></sup></label> 
            <select 
              name="dbFiles" placeholder="Search"
              class="form-select my-md-2 my-lg-0"  
              @change="getFieldsOne('database')"
              v-model="location" id="fileName">
                <option value=""  > None</option>
                <option v-for="file in dbDatasets" :key="file" :value="file">
                {{ file }}
              </option>
            </select>
            <span class="errormsg ml-0" v-if="validations[2] == true">
              {{ $t("navigations.please choose a value") }}
            </span>
          </div>
        </div>

         <div class="col-12 col-md-3 my-1 pl-lg-1 pr-lg-0">
          <div class="form-group mb-md-0">
            <label for="programNameField"
              >{{ $t("navigations.program name")
               }}
            </label>
            <input
              id="programNameField"
              type="text"
              class="form-control my-md-2 my-lg-0"
              v-model="programNameField"
            />
            <!-- <span class="errormsg ml-0" v-if="validations[0] == true">
              {{ $t("navigations.please enter a value") }}
            </span> -->
          </div>
        </div>

        <!-- <div class="col-12 col-md-4 my-1 pl-lg-1 pr-lg-1" v-if="LocationType == 'datalake'">
          <div class="form-group mb-md-0">
              <label for="fileName">
                {{ $t("navigations.dataset location") }}<sup><i class="fa fa-asterisk important-block px-1"></i></sup>
              </label>
              <VueSelect
                class="custom-type-select my-md-1 my-lg-0"
                v-model="location"
                :options="interimVersionFiles.ADAM_FIleName"
                placeholder="Type or select data location"
                :clearable="true"
                :taggable="true"
                :push-tags="true"
                @input="getFieldsOne('datalake')"
              />
              <span class="errormsg ml-0" v-if="validations[2] == true">
                {{ $t("navigations.please choose a value") }}
              </span>
          </div>
        </div> -->

        <div class="col-12 col-md-4 my-1 pl-lg-1 pr-lg-1" v-if="LocationType == 'datalake' && isEDC == true">
          <div class="form-group mb-md-0">
            <label for="fileName">{{ $t("navigations.dataset location")
              }}<sup><i class="fa fa-asterisk important-block px-1"></i></sup></label>
            <select 
              name="interim version" placeholder="Search"
              class="form-select my-md-2 my-lg-0"  
              @change="getFieldsOne('datalake')"
              v-model="location" id="interimVersion">
                <option value="" slected > None</option>
                <option v-for="file in interimVersionFiles.ADAM_FIleName" 
                          :key="file" 
                          :value="interimVersionFiles.Adam_FilePath+'/'+file">
                {{ file }}
              </option>
            </select>
            <span class="errormsg ml-0" v-if="validations[2] == true">
              {{ $t("navigations.please choose a value") }}
            </span>
          </div>
        </div>

        <div class="col-12 col-md-4 my-1 pl-lg-1 pr-lg-1" v-if="LocationType == 'datalake' && isEDC == false">
          <div class="form-group mb-md-0">
            <label for="programName"
              >{{ $t("navigations.dataset location")
              }}<sup><i class="fa fa-asterisk important-block px-1"></i></sup
            ></label>
            <input
              id="programName"
              type="text"
              class="form-control my-md-2 my-lg-0"
              v-model="location"
            />
            <span class="errormsg ml-0" v-if="validations[2] == true">
              {{ $t("navigations.please enter a value") }}
            </span>
          </div>
        </div>
         <div class="col-12 col-lg-2 col-md-2 my-1 pl-lg-1 pr-lg-0">
          <label for="returnType">{{ $t("navigations.program type")}}
              <sup><i class="fa fa-asterisk important-block px-1"></i></sup></label>
          <select class="form-select" name="account" id="returnType" placeholder="Search" v-model="programType">
            <option value="">{{ $t("navigations.none") }}</option>
            <option value="R">{{ $t("navigations.r") }}</option>
            <option value="Python"> {{ $t("navigations.python") }}</option>
            <option value="SAS"> {{ $t("navigations.sas") }}</option>
          </select>
          <span class="errormsg ml-0" v-if="validations[4] == true">
            {{ $t("navigations.please choose a value") }}
          </span>
        </div>
        <div class="col-12 col-lg-2 col-md-2 my-1 pl-lg-1 pr-lg-0">
          <label for="returnType">{{ $t("navigations.return type")
            }}<sup><i class="fa fa-asterisk important-block px-1"></i></sup></label>
          <select class="form-select" name="account" id="returnType" placeholder="Search" v-model="returnType">
            <option value="">
              {{ $t("navigations.none") }}
            </option>
            <option value="Pdf">
              {{ $t("navigations.pdf") }}
            </option>
            <option value="Html">
              {{ $t("navigations.html") }}
            </option>
          </select>
          <span class="errormsg ml-0" v-if="validations[5] == true">
            {{ $t("navigations.please choose a value") }}
          </span>
        </div>
        <div class="col-12 col-lg-2 my-1 col-md-2 my-1 pl-lg-1 pr-lg-0">
          <label for="orientation">{{ $t("navigations.orientation")
            }}<sup><i class="fa fa-asterisk important-block px-1"></i></sup></label>
          <select class="form-select" name="account" id="orientation" placeholder="Search" v-model="orientation">
            <option value="">
              {{ $t("navigations.none") }}
            </option>
            <option value="Landscape">
              {{ $t("navigations.landscape") }}
            </option>
            <option value="Portrait">
              {{ $t("navigations.portrait") }}
            </option>
          </select>
          <span class="errormsg ml-0" v-if="validations[6] == true">
            {{ $t("navigations.please choose a value") }}
          </span>
        </div>
        <div class="col-12 col-lg-3 my-1 col-md-3 my-1 pl-lg-1 pr-lg-0">
          <label for="reportType">{{ $t("navigations.report type")}}<sup><i class="fa fa-asterisk important-block px-1"></i></sup></label>
          <select @change="valueChange()" class="form-select" name="account"  id="reportType" placeholder="Search" v-model="reportType">
            <option value="">
              {{ $t("navigations.none") }}
            </option>
            <option value="Graph">
              {{ $t("navigations.graph") }}
            </option>
            <option value="Table">
              {{ $t("navigations.table") }}
            </option>
            <option value="Listing">
              {{ $t("navigations.listing") }}
            </option>
          </select>
          <span class="errormsg ml-0" v-if="validations[7] == true">
            {{ $t("navigations.please choose a value") }}
          </span>
        </div>
        <div class="col-12 col-lg-3 my-1 col-md-3 my-1 pl-lg-1 pr-lg-0" v-if="reportType=='Graph'">
          <label for="chartType">{{ $t("navigations.chart type") }}<sup><i class="fa fa-asterisk important-block px-1"></i></sup></label>
          <select class="form-select" name="account" id="chartType" placeholder="Search" v-model="chartType">
            <option value="">{{ $t('navigations.none') }}</option> 
            <option v-for="item in graphList" :key="item._id" :value="item._id">
              {{ item.Name }}
            </option>
          </select>
          <span class="errormsg ml-0" v-if="validations[8] == true">
            {{ $t("navigations.please choose a value") }}
          </span>
        </div>
        
       <div class="col-12 col-md-12 my-1 pl-lg-1 pr-lg-0 ">
        <div class="form-group mb-md-1">
        <label for="footNote">Foot Note</label>
        <textarea
          id="footNote"
          class="form-control my-md-2 my-lg-0"
          v-model="footnotes"
          rows="3"
          placeholder="Enter foot note"
        ></textarea>
        </div>
       </div>
        <div class="repeat-border-bottom"> </div>
        <div class="px-0 d-flex justify-content-between align-item-center mt-1">
          <label class="px-0">{{ $t("navigations.row filters") }}</label>
          <div
            class="position-relative"
            aria-label="add row"
            tabindex="0"
          >
            <img
              width="20"
              class="cursor-pointer"
              src="../../assets/img/create.png"
              alt="Create user"
              @click="addRow('row')"
            />
            <div class="tool-tip">{{ $t("navigations.add row") }}</div>
          </div>
        </div>
        <div v-for="(filter, index) in rowFilters" :key="index" class="row px-0 mx-0 mb-2">
          <!-- Field Name (dynamic key) -->
          <div class="col-12 col-md-4 pl-0">
            <div class="form-group mb-0">
              <label for="fieldName" class="mb-0">{{ $t("navigations.select a field") }}</label>
              <select class="form-select my-md-2"  name="account" id="fieldName" placeholder="Search"
                v-model="filter.ColumnName">
                <option value="">{{ $t('navigations.none') }}</option>
                <option v-for="field in rowFilterFields" :key="field" :value="field">
                  {{ field }}
                </option>
              </select>
              <span class="errormsg ml-0" v-if="
                rowFilterValidations &&
                rowFilterValidations[index] &&
                rowFilterValidations[index][0] == true
              ">
                {{ $t("navigations.please choose a value") }}
              </span>
            </div>
          </div>

          <!-- Operator Input -->
          <div class="col-12 col-md-4 pl-0">
            <div class="form-group mb-0">
              <label for="operator" class="mb-0">{{ $t("navigations.operator") }}</label>
              <!-- <label for="operator">{{ $t("navigations.operator") }}</label> -->
              <!-- <input type="text" class="form-control" v-model="filter.Operator" placeholder="Operator" /> -->
              <select class="form-select my-md-2" v-model="filter.Operator">
                <option value=""  > None</option>
                <!-- <option disabled value="">{{ $t("navigations.select operator") }}</option> -->
                <option v-for="op in getOperatorOptions(filter.ColumnName)" :key="op" :value="op">
                  {{ op }}
                </option>
              </select>
              <span class="errormsg ml-0" v-if="
                rowFilterValidations &&
                rowFilterValidations[index] &&
                rowFilterValidations[index][1] == true
              ">
                {{ $t("navigations.please enter a value") }}
              </span>
            </div>
          </div>

          <!-- Value Input -->
          <div class="col-12 col-md-3 pl-0">
            <div class="form-group mb-0">
              <label for="value">{{ $t("navigations.value")}}</label>
              <input type="text" class="form-control" v-model="filter.Value" placeholder="Value" />
              <span class="errormsg ml-0" v-if="
                rowFilterValidations &&
                rowFilterValidations[index] &&
                rowFilterValidations[index][2] == true
              ">
                {{ $t("navigations.please enter a value") }}
              </span>
            </div>
          </div>

          <!-- Delete Button -->
          <div class="col-12 col-md-1 pl-0 my-1 align-self-end">
            <button class="btn-circle position-relative" type="button" @click.prevent="deleteFilter('row', index)">
              <i class="fa fa-minus"></i>
              <div class="tool-tip">{{ $t("navigations.delete") }}</div>
            </button>
          </div>
        </div>
        <div class="repeat-border-bottom"></div>   
        <div class="row pl-0 pr-0 mx-0">   
          <div class="col-4 pl-0 my-1 pr-lg-1" v-if="reportType != 'Graph' && reportType != 'Listing'">
              <div class="form-group mb-md-0">
                <label for="uniqueField">{{ $t("navigations.unique field") }}</label>
                <select class="form-select"  name="account" id="uniqueField" placeholder="Search"
                  v-model="uniqueField" @change="uniqueFieldUpdated()">
                  <option value="">{{ $t('navigations.none') }}</option>
                  <option v-for="field in columnFilters" :key="field" :value="field">
                    {{ field }}
                  </option>
                </select>
                <!-- <span
                  class="errormsg ml-0"
                  v-if="
                    rowFilterValidations &&
                      rowFilterValidations[index] &&
                      rowFilterValidations[index][0] == true
                  "
                >
                  {{ $t("navigations.please choose a value") }}
                </span> -->
              </div>
          </div> 
          <div  class="col-4 pl-0 my-1 pr-lg-1">         
            <div class="form-group mx-0 mb-md-0">
              <label for="columnFilters"
                >{{ $t("navigations.column filters")
                }}<sup><i class="fa fa-asterisk important-block px-1"></i></sup
              ></label>
              <Multiselect
                id="columnFilters"
                valueProp="value"
                v-model="columnFieldNames"
                mode="multiple"
                @update:modelValue="columnFilterChange($event)"
                @clear="onClearClicked()"
                :options="columnFiltersValues"
                :searchable="true"
                :hideSelected="false"
                :closeOnSelect="false"
                class="multiselect-theme mr-0"
              >
              </Multiselect>
              <span class="errormsg ml-0" v-if="validations[9] == true">
                {{ $t("navigations.please choose a value") }}
              </span>
            </div>
          </div>
          <div class="pl-0 my-1 col-4 pr-lg-1" v-if="reportType === 'Table'"> 
            <div class="form-group mb-md-0">
              <label for="groupBy"
                >{{ $t("navigations.group by")
                }}<sup><i class="fa fa-asterisk important-block px-1"></i></sup
              ></label>
              <select
                class="form-select"
                name="account"
                id="groupBy"
                placeholder="Search"
                v-model="groupByField"
              >
                <option value="">{{ $t("navigations.none") }}</option>
                <option
                  v-for="field in groupByFilter"
                  :key="field"
                  :value="field"
                >
                  {{ field }}
                </option>
              </select>
              <span class="errormsg ml-0" v-if="validations[10] == true">
                {{ $t("navigations.please choose a value") }}
              </span>
            </div>
          </div>
          <div
            v-if="reportType == 'Table' && this.uniqueField != ''"
            class="selected-field  row pl-0 my-1"
          >
            <div
              class="col-3 d-flex align-items-start"
              v-for="(field, index) in columnFieldNames"
              :key="index"
            >
              <div class="form-group w-100 mx-0 mb-md-0">
                <label :for="field" class="px-0"
                  >{{ field }}
                  <sup><i class="fa fa-asterisk important-block px-1"></i></sup
                ></label>
                <Multiselect
                  :id="field"
                  :name="field"
                  valueProp="value"
                  v-model="dropdownSelections[field]"
                  @clear="onFilterValueCleard(field)"
                  mode="multiple"
                  :options="fieldValues[field]"
                  :searchable="true"
                  :hideSelected="false"
                  :closeOnSelect="false"
                  class="multiselect-theme mr-0"
                >
                </Multiselect>
                <span
                  class="errormsg ml-0"
                  v-if="columnErrorList[field] == true"
                >
                  {{ $t("navigations.please choose a value") }}
                </span>
              </div>

              <button type="button" class="btn" @click="removeField(field)">
                ×
              </button>
            </div>
          </div>
        </div>
     
        <div class="col-12 col-md-4 pl-0 my-1  pr-lg-1">
          <label for="fieldName">{{ $t("navigations.page group") }}</label>
          <select
            class="form-select"
            name="account"
            id="fieldName"
            placeholder="Search"
            v-model="pageGroup"
          >
            <option value="">{{ $t("navigations.none") }}</option>
            <option v-for="field in groupByFilter" :key="field" :value="field">
              {{ field }}
            </option>
          </select>
        </div>
        <div class="col-12 col-md-4 pl-0 my-1  pr-lg-1" v-if="setMacro==false">
          <label for="chartType">{{ $t("navigations.primary programmer")}}</label>
          <select v-model="developerName" class="form-select"  name ="programmer" id="programmer">
            <option value="">{{ $t('navigations.none') }}</option>
            <option :value="user.fullName" v-for="user in userList" :key="user.id">
                {{ user.fullName}}
            </option>
          </select>
        </div>
        <div class="col-12 col-md-4 pl-0 my-1  pr-lg-1" v-if="setMacro==false">
          <label for="chartType"> {{ $t("navigations.qc programmer")}} </label>
          <select v-model="qcName" class="form-select"  name ="programmer" id="programmer">
            <option value="">{{ $t('navigations.none') }}</option>
            <option :value="user.fullName" v-for="user in userList" :key="user.id">
              {{ user.fullName}}
            </option>
          </select>
        </div>
        <!-- <div class="col-12 col-md-4 pl-0 my-1  pr-lg-1" v-if="setMacro==false">
          <label for="status">{{ $t("navigations.status")
            }}<sup><i class="fa fa-asterisk important-block px-1"></i></sup></label>
         <select class="form-select" name="account" id="status" placeholder="Search" v-model="status">
            <option value="">
              {{ $t("navigations.none") }}
            </option>

            <option value="Ready For Validation">
              {{ $t("navigations.ready for validation") }}
            </option>
            <option value="In Development">
              {{ $t("navigations.in development") }}
            </option>
            <option value="Validated">
              {{ $t("navigations.validated") }}
            </option>
          </select>
          <span class="errormsg ml-0" v-if="validations[11] == true">
            {{ $t("navigations.please choose a value") }}
          </span>
        </div> -->
        <div class="col-12 col-md-4 pl-0 my-1  pr-lg-1 pb-2" v-if="reportType != 'Graph'">
          <label for="numericOperations">{{ $t("navigations.numeric operations")}}</label>
          <Multiselect v-model="numericOperations"  mode="multiple" :searchable="true" :options="numericOperationValues" id="numericOperations"
              :hideSelected="false" :closeOnSelect="false" class="multiselect-theme mr-0">
            </Multiselect>
          <span class="errormsg ml-0" v-if="validations[12] == true">
            {{ $t("navigations.please choose a value") }}
          </span>
        </div>
         <div class="repeat-border-bottom"></div>
         <div class="col-12 col-md-4 my-1 pl-lg-1 pr-lg-0">
          <div class="form-group mb-md-0">
            <label for="programpath"
              >Program Path</label>
            <div class="input-group">
              <span class="input-group-text" style="background-color: #e9ecef; border: 1px solid #ced4da; padding: 0.2rem 0.4rem; font-size: 0.760rem; white-space: nowrap;">
                {{ programPath }}
              </span>
              <input
                id="programPath"
                type="text"
                class="form-control my-md-2 my-lg-0"
                v-model="programPathInput"
                style="flex: 1;"
              />
            </div>
            <span class="errormsg ml-0" style="font-size: 12px;" v-if="programPathError">
              Please use '/'or '\\' in path; more than two '\\' is not allowed.
            </span>
          </div>
        </div>
        <div class="repeat-border-bottom pb-2"></div>
        <div class="col-md-12 my-1 pl-0 pr-lg-1">

        <!-- Header -->
      <div class="d-flex justify-content-between align-items-center mb-2 mt-2">

       <div class="d-flex align-items-center">
        <!-- <i class="fa fa-code mr-2 text-primary"></i> -->
        <span class="">
          R Program
        </span>
      </div>

      <div class="d-flex align-items-center">
        <span class="mr-2">
          Upload custom R file
        </span>

        <label class="switch mb-0">
          <input
            type="checkbox"
            v-model="customFile"
            @change="onAutoGenToggle()"
          >
          <span class="slider"></span>
        </label>
      </div>

      </div>

     <!-- Upload Area: shown only when toggle is ON -->
      <div
        v-if="customFile"
        class="upload-box"
        @dragover.prevent
        @drop.prevent="handleDrop"
      >
        <div class="text-center">
          <i class="fa fa-cloud-upload fa-3x text-muted mb-3"></i>
          <div>Drag &amp; drop your .r file here, or</div>
          <div class="small text-muted mb-3">Only .r / .R files allowed · Max 5 MB</div>
          <button
            class="btn btn-primary font-weight-bold"
            style="padding: 3px 12px; font-size: 11px; border-radius: 4px;"
            @click="$refs.file.click()"
          >
            <i class="fa fa-folder-open mr-1" style="font-size: 11px;"></i>
            Browse file
          </button>
          <input
            ref="file"
            type="file"
            hidden
            accept=".r,.R"
            @change="handleFileUpload"
          >
        </div>
      </div>

      <!-- Selected file status & info banners -->
      <div v-if="customFile">
        <!-- Selected file card -->
        <div v-if="selectedFile" class="selected-file-card mb-3">
          <div class="d-flex align-items-center justify-content-between w-100">
            <div class="d-flex align-items-center">
              <div class="file-icon-wrapper">
                <i class="fa fa-file-code-o fa-lg" style="color: #ffffff;"></i>
              </div>
              <div class="file-info-col">
                <div class="file-title">{{ selectedFile.name }}</div>
                <div class="file-meta">
                  {{ formatBytes(selectedFile.size) }} · Selected: {{ fileSelectedTime }}
                </div>
                <div class="file-sha" v-if="fileHash">
                  SHA-256: 
                  <span class="sha-badge">{{ fileHash }}</span>
                  <button class="copy-hash-btn" @click.prevent="copyHashToClipboard" title="Copy SHA-256 hash">
                    <i class="fa" :class="copySuccess ? 'fa-check text-success' : 'fa-copy'"></i>
                  </button>
                  <span v-if="copySuccess" class="text-success small ml-1" style="font-size: 10px;">Copied!</span>
                </div>
              </div>
            </div>
            <div class="card-actions">
              <button class="btn btn-sm btn-outline-primary btn-replace" @click.prevent="$refs.file.click()">
                <i class="fa fa-refresh mr-1"></i> Replace
              </button>
              <button class="btn btn-sm btn-outline-danger btn-remove" @click.prevent="removeSelectedFile">
                <i class="fa fa-trash mr-1"></i> Remove
              </button>
            </div>
          </div>
        </div>

        <!-- File ready text -->
        <div v-if="selectedFile" class="file-ready-text mb-3">
          <i class="fa fa-circle text-success" style="font-size: 8px;"></i> 
          File ready — click "Upload & Save Program" to register
        </div>

        <!-- Warning banner -->
      <div v-if="!selectedFile" class="auto-generate-warning mb-3">
      <i class="fa fa-lightbulb-o" style="font-size: 14px; margin-top: 2px;"></i>

      <div v-if="programPathInput">
       Repository program mode — the R program will be executed from the provided path. The script must exist in the study repository; no auto-generation will occur.
      </div>

      <div v-else>
    Auto-generate mode — the R program will be generated automatically on first run based on the report configuration above. No file upload required.
      </div>
    </div>
      </div>

      <!-- Auto-generate mode info: shown only when toggle is OFF and no program path -->
      <div v-else-if="!programPathInput" class="auto-generate-info mt-2">
        <i class="fa fa-magic mr-2" style="color: #ffffff;"></i>
        <span class="font-weight-bold" style="color: #018ae6;">Auto-generate mode</span> — the R program will be generated automatically on first run based on the report configuration above. No file upload required.
      </div>

      <!-- Repository mode when program path is provided -->
      <div v-else class="auto-generate-warning mt-2">
        <i class="fa fa-lightbulb-o" style="font-size: 14px; margin-top: 2px;"></i>
        Repository program mode — the R program will be executed from the provided path. The script must exist in the study repository; no auto-generation will occur.
      </div>

        </div>
        <div class="row px-0 mx-0">
          <!-- <div class="col-12 col-md-1 my-1 align-self-end px-0">
            <button
              type="button"
              class="save_btn py-2 px-3 w-100 position-relative"
              :disabled="loadingBlock == true"
              @click.prevent="exBtnClicked()"
              :class="{ 'disabled-btn-cls': loadingBlock == true }"
            >
              <div
                class="toc-loader position-absolute"
                :class="{
                  'opacity-0': loadingBlock == false,
                  'opaciyt-1': loadingBlock == true,
                }"
              >
                <img
                  src="../../assets/img/loading.gif"
                  width="15"
                  class="loading-btn-img"
                  alt="Waiting for login"
                />
              </div>
              <div
                :class="{
                  'opacity-1': loadingBlock == false,
                  'opacity-0': loadingBlock == true,
                }"
              >
                {{ $t("navigations.view") }}
              </div>
            </button>
          </div> -->

          <div
            class="col-12 col-md-4 my-2 align-self-end px-0"
            v-if="showCreate == true || setMacro == true"
          >
            <div class="d-flex align-items-center animate-buttons" style="gap: 10px;">
              <button
                v-if="editoption == '0' || id == '0'"
                type="button"
                class="save_btn py-1 px-3 position-relative"
                :disabled="loadingSaveBlock == true"
                @click.prevent="saveData()"
                :class="{ 'disabled-btn-cls': loadingSaveBlock == true }"
                style="min-width: 90px;"
              >
                <div
                  class="toc-loader position-absolute"
                  :class="{
                    'opacity-0': loadingSaveBlock == false,
                    'opaciyt-1': loadingSaveBlock == true,
                  }"
                >
                  <img
                    src="../../assets/img/loading.gif"
                    width="15"
                    class="loading-btn-img"
                    alt="Waiting for login"
                  />
                </div>
                <div
                  :class="{
                    'opacity-1': loadingSaveBlock == false,
                    'opacity-0': loadingSaveBlock == true,
                  }"
                >
                  {{ $t("navigations.create") }}
                </div>
              </button>
              <button
                v-if="editoption == '1'"
                type="button"
                class="save_btn py-1 px-3 position-relative"
                :disabled="loadingSaveBlock == true"
                @click.prevent="saveData()"
                :class="{ 'disabled-btn-cls': loadingSaveBlock == true }"
              >
                <div
                  class="toc-loader position-absolute"
                  :class="{
                    'opacity-0': loadingSaveBlock == false,
                    'opaciyt-1': loadingSaveBlock == true,
                  }"
                >
                  <img
                    src="../../assets/img/loading.gif"
                    width="15"
                    class="loading-btn-img"
                    alt="Waiting for login"
                  />
                </div>
                <div
                  :class="{
                    'opacity-1': loadingSaveBlock == false,
                    'opacity-0': loadingSaveBlock == true,
                  }"
                >
                  <i class="fa fa-save mr-1" style="font-size: 11px;"></i> {{ $t("navigations.update") }}
                </div>
              </button>
              <button
                v-if="customFile && selectedFile"
                type="button"
                class="save_btn py-1 px-3 position-relative"
                :disabled="loadingSaveBlock == true"
                @click.prevent="uploadAndSaveData()"
                :class="{ 'disabled-btn-cls': loadingSaveBlock == true }"
                style="background-color: #0b6647 !important; border-color: #0b6647 !important; color: white !important; font-weight: bold; white-space: nowrap; min-width: 175px;"
              >
                <div
                  class="toc-loader position-absolute"
                  :class="{
                    'opacity-0': loadingSaveBlock == false,
                    'opaciyt-1': loadingSaveBlock == true,
                  }"
                >
                  <img
                    src="../../assets/img/loading.gif"
                    width="15"
                    class="loading-btn-img"
                    alt="Uploading"
                  />
                </div>
                <div
                  :class="{
                    'opacity-1': loadingSaveBlock == false,
                    'opacity-0': loadingSaveBlock == true,
                  }"
                >
                  <i class="fa fa-upload mr-1" style="font-size: 11px;"></i> Upload &amp; Save Program
                </div>
              </button>
              <!-- <button
                type="button"
                class="btn btn-outline-secondary py-1 px-3 font-weight-bold"
                @click.prevent="cancel()"
                style="background-color: #ffffff !important; border: 1px solid #ced4da !important; color: #495057 !important; min-width: 90px; border-radius: 4px; padding: 0.35rem 0.75rem;"
              >
                <i class="fa fa-times mr-1" style="font-size: 11px; color: #dc3545;"></i> Cancel
              </button> -->
            </div>
          </div>
          <div class="col-12 col-md-4 my-1 align-self-end px-0 mt-1" v-else>
            <div class="d-flex align-items-center animate-buttons" style="gap: 10px;">
              <button
                type="button"
                class="save_btn py-1 px-3 position-relative"
                :disabled="loadingSaveBlock == true"
                @click.prevent="saveData()"
                :class="{ 'disabled-btn-cls': loadingSaveBlock == true }"
                style="min-width: 90px;"
              >
                <div
                  class="toc-loader position-absolute"
                  :class="{
                    'opacity-0': loadingSaveBlock == false,
                    'opaciyt-1': loadingSaveBlock == true,
                  }"
                >
                  <img
                    src="../../assets/img/loading.gif"
                    width="15"
                    class="loading-btn-img"
                    alt="Waiting for login"
                  />
                </div>
                <div
                  :class="{
                    'opacity-1': loadingSaveBlock == false,
                    'opacity-0': loadingSaveBlock == true,
                  }"
                >
                  <i class="fa fa-save mr-1" style="font-size: 11px;"></i> {{ $t("navigations.save") }}
                </div>
              </button>
              <button
                v-if="customFile && selectedFile"
                type="button"
                class="save_btn py-1 px-3 position-relative"
                :disabled="loadingSaveBlock == true"
                @click.prevent="uploadAndSaveData()"
                :class="{ 'disabled-btn-cls': loadingSaveBlock == true }"
                style="background-color: #0b6647 !important; border-color: #0b6647 !important; color: white !important; font-weight: bold; white-space: nowrap; min-width: 175px;"
              >
                <div
                  class="toc-loader position-absolute"
                  :class="{
                    'opacity-0': loadingSaveBlock == false,
                    'opaciyt-1': loadingSaveBlock == true,
                  }"
                >
                  <img
                    src="../../assets/img/loading.gif"
                    width="15"
                    class="loading-btn-img"
                    alt="Uploading"
                  />
                </div>
                <div
                  :class="{
                    'opacity-1': loadingSaveBlock == false,
                    'opacity-0': loadingSaveBlock == true,
                  }"
                >
                  <i class="fa fa-upload mr-1" style="font-size: 11px;"></i> Upload &amp; Save Program
                </div>
              </button>
              <button
                type="button"
                class="btn btn-outline-secondary py-1 px-3 font-weight-bold"
                @click.prevent="cancel()"
                style="background-color: #ffffff !important; border: 1px solid #ced4da !important; color: #495057 !important; min-width: 90px; border-radius: 4px; padding: 0.35rem 0.75rem;"
              >
                <i class="fa fa-times mr-1" style="font-size: 11px; color: #dc3545;"></i> Cancel
              </button>
            </div>
          </div>
        </div>

        <!-- Table contents end -->
      </div>
      <!-- modal starts -->
      <div class="iframe-wrapper" v-if="displayModal == true">
        <div class="iframe-container">
          <div class="titleclass d-flex justify-content-between py-2 px-3">
            <h4 class="my-0">{{ $t("navigations.data modal") }}</h4>
            <a class="close-link">
              <i class="fa fa-times" @click.prevent="displayModal = false"></i>
            </a>
          </div>
          <div class="iframe-body  width-height p-4">
            <template v-for="(page, index) in dataPages" :key="index">
              <iframe
                class="iframe-block"
                :id="`${page.Page}-${index}`"
                style="border: none;"
              >
              </iframe>
            </template>
          </div>
        </div>
      </div>
      <!-- modal ends -->
    </div>
  </div>
</template>
<script src="./Stats.js"></script>
<style scoped>
.custom-type-select{
  --vs-font-size:0.8rem;
  --vs-height:27px;
  --vs-border-radius:0;
}
.multiselect-theme {
  --ms-radius: 0;
  --ms-py: 0.4rem;
  --ms-option-font-size: 0.8rem;
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
}

.important-block {
  color: rgb(255, 0, 0);
  font-size: 7px;
}

.iframe-wrapper {
  position: fixed;
  display: grid;
  place-items: center;
  inset: 0;
  background: rgb(0 0 0 / 30%);
  transition: cubic-bezier;
  overflow: hidden;
  z-index: 10000;
}

.iframe-container {
  width: min(700px, 90%);
  background: #fff;
  border-radius: 4px;
  transition: all 0.3s ease-in-out;
}

.loading-btn-img {
  display: block;
  mix-blend-mode: lighten;
}

.disabled-btn-cls {
  opacity: 0.6;
  pointer-events: none;
}

.auto-generate-info {
  background: #eef0ff;
  border-left: 4px solid #018ae6;
  border-radius: 4px;
  padding: 0.55rem 0.9rem;
  color: #000000;
  font-size: 11px;
}

.repeat-border-bottom {
  border-bottom: 1px dashed hsl(237, 42%, 40%);
}

.iframe-block {
  width: 100%;
  height: 500px;
}

.width-height {
  height: 500px;
  overflow: auto;
}

.toc-loader {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.opacity-0 {
  opacity: 0;
}

.opacity-1 {
  opacity: 1;
}
.upload-box{
    min-height:165px;
    border:2px dashed #b7c7e2;
    border-radius:8px;
    background:#f8f9fc;

    display:flex;
    align-items:center;
    justify-content:center;
}

.switch{
    position:relative;
    width:40px;
    height:22px;
}

.switch input{
    display:none;
}

.slider{
    position:absolute;
    inset:0;
    cursor:pointer;
    background:#ccc;
    border-radius:20px;
    transition:.3s;
}

.slider::before{
    content:"";
    position:absolute;

    width:16px;
    height:16px;

    left:3px;
    top:3px;

    border-radius:50%;
    background:white;
    transition:.3s;
}

input:checked + .slider{
    background:#1565c0;
}

input:checked + .slider::before{
    transform:translateX(18px);
}

.selected-file-card {
  background: #f0f4fc;
  border: 1px solid #d1dcf0;
  border-radius: 8px;
  padding: 15px;
  display: flex;
  align-items: center;
  margin-top: 15px;
  font-family: inherit;
}

.file-icon-wrapper {
  background: #1565c0;
  border-radius: 6px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}

.file-info-col {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.file-title {
  font-weight: bold;
  font-size: 13px;
  color: #2c3e50;
  margin-bottom: 2px;
}

.file-meta {
  font-size: 11px;
  color: #7f8c8d;
  margin-bottom: 4px;
}

.file-sha {
  font-size: 11px;
  color: #7f8c8d;
  display: flex;
  align-items: center;
}

.sha-badge {
  background: #e8f5e9;
  color: #2e7d32;
  border-radius: 4px;
  padding: 1px 6px;
  font-family: monospace;
  font-size: 10px;
  border: 1px solid #c8e6c9;
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.copy-hash-btn {
  border: none;
  background: none;
  cursor: pointer;
  color: #7f8c8d;
  padding: 0 4px;
  font-size: 12px;
  transition: color 0.2s;
  outline: none;
}

.copy-hash-btn:hover {
  color: #1565c0;
}

.card-actions {
  display: flex;
  gap: 8px;
}

.btn-replace {
  border: 1px solid #b2cbf2 !important;
  color: #1565c0 !important;
  background-color: #ffffff !important;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: bold;
  transition: background-color 0.2s;
}

.btn-replace:hover {
  background-color: #e3edfc !important;
}

.btn-remove {
  border: 1px solid #f9d5d5 !important;
  color: #d9534f !important;
  background-color: #ffffff !important;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: bold;
  transition: background-color 0.2s;
}

.btn-remove:hover {
  background-color: #fdf0f0 !important;
}

.file-ready-text {
  color: #2e7d32;
  font-size: 12px;
  margin-top: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 6px;
}

.auto-generate-warning {
  background: #fff9e6;
  border: 1px solid #ffeeba;
  border-left: 4px solid #ffc107;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 11px;
  color: #856404;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 15px;
  line-height: 1.4;
}

.animate-buttons button {
  transition: all 0.2s ease-in-out;
}

.custom-tooltip{
visibility: hidden;
    -width: 60px;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 8px;
    position: absolute;
    z-index: 1;
    bottom: -10px;
    left: -36px;
    margin-left: -30px;
    opacity: 0;
    transition: opacity 0.3s;
    font-size: 12px;}
</style>
